import { bffCrmPersonAdditionalBenefits } from '@fireflyhealth/api'
import type { BffCrmPersonAdditionalBenefitsRetrieveResponse } from '@fireflyhealth/api'

import { keepPreviousData } from '@tanstack/react-query'
import { useQuery } from '~/shared/hooks/query'

const personAdditionalBenefitsQueryKey = (
  personId: number,
  policyConfigurationId: number | undefined,
) =>
  bffCrmPersonAdditionalBenefits.retrieveQueryKey(
    { person_id: personId },
    { policy_configuration_id: policyConfigurationId },
  )

/**
 * Fetches a member's additional benefits for one plan year, the years on offer, and the one they
 * came from. `policyConfigurationId` must be one of the returned `policy_configurations`; any
 * other is a 400. Disabled until `personId` is available.
 */
export const useGetPersonAdditionalBenefits = (variables: {
  personId: number | undefined
  policyConfigurationId?: number
}) => {
  const { personId, policyConfigurationId } = variables
  return useQuery<BffCrmPersonAdditionalBenefitsRetrieveResponse>(
    personId != null
      ? personAdditionalBenefitsQueryKey(personId, policyConfigurationId)
      : ['retrieveBffCrmPersonAdditionalBenefits', {}],
    async () =>
      (
        await bffCrmPersonAdditionalBenefits.retrieve(
          { person_id: Number(personId) },
          { params: { policy_configuration_id: policyConfigurationId } },
        )
      ).data,
    { enabled: personId != null, placeholderData: keepPreviousData },
    { error: 'Failed to fetch additional benefits' },
  )
}
